// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__M5-yP","backgroundVideo":"Hero_backgroundVideo__-fJvy","heroContent":"Hero_heroContent__AGvi6","heroLogo":"Hero_heroLogo__lPfOW"};